import React, { FC, memo } from 'react';
import classNames from 'classnames';
import { ICategoryTab } from '../../types';
import './index.scss';

interface ICategoryTabsProps {
  /** 当前激活的分类 key */
  activeCategory: string;
  /** 切换分类回调 */
  onChange: (category: string) => void;
  /** 分类 TAB 列表（从接口数据动态生成） */
  tabs: ICategoryTab[];
  /** 自定义样式类名 */
  className?: string;
}

/**
 * 分类 TAB 组件
 * tabs 数据由父组件从接口数据中动态提取传入
 */
const CategoryTabs: FC<ICategoryTabsProps> = ({
  activeCategory,
  onChange,
  tabs,
  className,
}) => {
  return (
    <div className={classNames('dba-category-tabs', className)}>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={classNames('dba-category-tabs__item', {
            'dba-category-tabs__item--active': activeCategory === tab.key,
          })}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default memo(CategoryTabs);
